export class MetricsFactory {
  public static getPath(): string {
    return 'metrics';
  }
}
